// extracted by mini-css-extract-plugin
export default {"control":"AddMovie_control__Z62BQ","invalid":"AddMovie_invalid__r1C-L"};